import { render, staticRenderFns } from "./NeedOptions.vue?vue&type=template&id=9a529384&scoped=true&"
import script from "./NeedOptions.vue?vue&type=script&lang=js&"
export * from "./NeedOptions.vue?vue&type=script&lang=js&"
import style0 from "./NeedOptions.vue?vue&type=style&index=0&id=9a529384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a529384",
  null
  
)

export default component.exports